import { useIntl } from "react-intl";
import { QuestionsTranslationWrapper } from "../Questions/questionTranslationWapper";

export const TranslationWrapper = ({ component }) => {
  const intl = useIntl();
  let convertedComponent;
  const translate = (text) => {
    return intl.formatMessage({
      id: text,
      defaultMessage: text,
      description: "",
    });
  };

  // Call converter functions based on the type of component
  switch (component.type) {
    case "CSCQ":
    case "OEQ":
    case "MSCQ":
    case "COLOR_PREDICTION":
    case "TABLE_QUESTION":
      convertedComponent = QuestionsTranslationWrapper(component);
      break;
    case "SLIDER_IMAGE":
      convertedComponent = {
        ...component,
        animationText: translate(component.animationText),
        sliderText: translate(component.sliderText),
        sliderAnimationAltText: translate(component.sliderAnimationAltText),
      };
      break;
    default:
      convertedComponent = component;
      break;
  }
  return convertedComponent;
};
